'use strict';

angular.module('TurneroApp').service('tramiteService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Tramite/:id', { id: '@Id_Tramite' }, {
        Get_X_Agenda: {
            method: 'GET',
            //params: {
            //    id_centro_atencion: '@id_centro_atencion',
            //    id_agenda: '@id_agenda'
            //},
            headers: portal.getHeadersServer(),
            cancellable: true
        },
        tramitesXUnidad: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/tramitesXUnidad/',
            headers: portal.getHeadersServer()
        },
        Get_Online: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/Get_Online/',
        },
        Get_Telefonicos: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/Get_Telefonicos/'
        },
        Get_Tramite_Detalle: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/Get_Tramite_Detalle/'
        },
        Get_Tramite: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/Get_Tramite/'
        },
        Get_Tramite_Telef_Combo: {
        	method: 'GET',
        	url: portal.getUrlServer() + 'api/Tramite/Get_Tramite_Telef_Combo'
        },
        Validar_Requerimientos: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/Validar_Requeridos'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/tramite-service.js